<template>
  <!-- 描述 -->
  <div class="Minister-top information">
    <div class="Minister-top-top Ministerbackground">
      <div class="Minister-top-left Minister-top-color">描述</div>
    </div>
    <div class="information_content" v-if="system == 5 && !isChakan">
      <div class="information_input" style="margin-bottom: 10px">
        <div class="information_Title">添加行</div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-select
              :disabled="system < 5 || isChakan"
              v-model="descType"
              placeholder="请选择"
              style="width: 30%"
            >
              <el-option label="文字" value="TEXT"></el-option>
              <el-option label="图片" value="IMAGE"></el-option>
              <el-option label="图片 + 文字" value="IMAGE&TEXT"></el-option>
              <el-option label="文字 + 图片" value="TEXT&IMAGE"></el-option>
              <el-option label="图片 + 图片" value="IMAGE&IMAGE"></el-option>
            </el-select>
            <el-button
              v-if="system == 5 && !isChakan"
              type="primary"
              @click="addNewType"
              icon="el-icon-plus"
              style="margin-left: 10px"
            ></el-button>
          </div>
        </div>
      </div>
      <div :key="keuNun">
        <div
          v-for="(item, index) in descList"
          :key="index"
          class="desc_item_box"
        >
          <div class="descText_title">描述</div>
          <div class="descText_box">
            <div class="opea_title">
              <span>{{ item.descType | getDescTypeStr }}</span>
              <div class="opea_button">
                <i
                  class="el-icon-top icon_item"
                  style="color: #0724ef"
                  @click="handleShangyi(index)"
                  v-if="index > 0"
                ></i>
                <i
                  v-if="index != descList.length - 1"
                  class="el-icon-bottom icon_item"
                  style="color: #0724ef"
                  @click="handleXiayi(index)"
                ></i>
                <i
                  class="el-icon-delete icon_item"
                  style="color: #0724ef"
                  @click="handleDelete(index)"
                ></i>
                <i
                  class="el-icon-document-copy icon_item"
                  style="color: #0724ef"
                  @click="handleCopy(index)"
                ></i>
              </div>
            </div>
            <!--     文字       -->
            <template v-if="item.descType == 'TEXT'">
              <div class="content_desc">
                <tinymce
                  :toolbar="['undo redo formatselect bold bullist numlist']"
                  block_formats="Paragraph=p;Header 1=h1;Header 2=h2"
                  :pasteFN="pasteFN"
                  :contextmenu="false"
                  :isShowWord="false"
                  ref="tinymce"
                  v-model="item.content"
                  :height="220"
                  class="add-notice-row"
                />
              </div>
            </template>
            <!--     图片       -->
            <template v-if="item.descType == 'IMAGE'">
              <div class="content_desc descImage_box">
                <img
                  width="200px"
                  height="200px"
                  v-if="item.imageUrl"
                  :src="item.imageUrl"
                  @click="addIamgeToItem(index)"
                  class="avatar_img"
                />
                <i
                  v-else
                  @click="addIamgeToItem(index)"
                  class="el-icon-plus avatar-uploader-icon add_img_icon"
                ></i>
              </div>
            </template>
            <!--     图片+文字       -->
            <template v-if="item.descType == 'IMAGE&TEXT'">
              <div class="commonBox">
                <div class="descImage_box">
                  <img
                    v-if="item.imageUrl"
                    :src="item.imageUrl"
                    @click="addIamgeToItem(index)"
                    class="avatar_img"
                  />
                  <i
                    v-else
                    @click="addIamgeToItem(index)"
                    class="el-icon-plus avatar-uploader-icon add_img_icon"
                  ></i>
                </div>
                <div class="descText">
                  <tinymce
                    :toolbar="['undo redo formatselect bold bullist numlist']"
                    block_formats="Paragraph=p;Header 1=h1;Header 2=h2"
                    :pasteFN="pasteFN"
                    :contextmenu="false"
                    :isShowWord="false"
                    ref="tinymce"
                    v-model="item.content"
                    :height="220"
                    class="add-notice-row"
                  />
                </div>
              </div>
            </template>
            <!--     文字 + 图片     -->
            <template v-if="item.descType == 'TEXT&IMAGE'">
              <div class="commonBox">
                <div class="descText">
                  <tinymce
                    :toolbar="['undo redo formatselect bold bullist numlist']"
                    block_formats="Paragraph=p;Header 1=h1;Header 2=h2"
                    :pasteFN="pasteFN"
                    :contextmenu="false"
                    :isShowWord="false"
                    ref="tinymce"
                    v-model="item.content"
                    :height="220"
                    class="add-notice-row"
                  />
                </div>
                <div class="descImage_box">
                  <img
                    v-if="item.imageUrl"
                    :src="item.imageUrl"
                    @click="addIamgeToItem(index)"
                    class="avatar_img"
                  />
                  <i
                    v-else
                    @click="addIamgeToItem(index)"
                    class="el-icon-plus avatar-uploader-icon add_img_icon"
                  ></i>
                </div>
              </div>
            </template>
            <!--     图片 + 图片     -->
            <template v-if="item.descType == 'IMAGE&IMAGE'">
              <div class="commonBox">
                <div class="descImage_box">
                  <img
                    v-if="item.imageUrl"
                    :src="item.imageUrl"
                    @click="addIamgeToItem(index)"
                    class="avatar_img"
                  />
                  <i
                    v-else
                    @click="addIamgeToItem(index)"
                    class="el-icon-plus avatar-uploader-icon add_img_icon"
                  ></i>
                </div>
                <div class="descImage_box">
                  <img
                    v-if="item.imageUrl1"
                    :src="item.imageUrl1"
                    @click="addIamgeToItem(index, 'imageUrl1')"
                    class="avatar_img"
                  />
                  <i
                    v-else
                    @click="addIamgeToItem(index, 'imageUrl1')"
                    class="el-icon-plus avatar-uploader-icon add_img_icon"
                  ></i>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="information_content" v-else>
      <div :key="keuNun">
        <div
          v-for="(item, index) in descList"
          :key="index"
          class="desc_item_box"
          style="margin-top: 20px"
        >
          <div class="descText_title" style="font-size: 18px">
            <span>{{ item.descType | getDescTypeStr }}</span>
          </div>
          <div
            v-if="item.descType == 'TEXT'"
            class="descText_box"
            style="display: flex; align-items: center; font-size: 22px"
          >
            <span v-html="item.content"></span>
          </div>
          <div v-if="item.descType == 'IMAGE'" class="descText_box">
            <div class="content_desc">
              <img
                width="200px"
                height="200px"
                v-if="item.imageUrl"
                :src="item.imageUrl"
                class="avatar_img"
              />
            </div>
          </div>
          <div
            v-if="item.descType == 'IMAGE&TEXT'"
            class="descText_box commonBox detail"
          >
            <div class="descImage_box">
              <img
                v-if="item.imageUrl"
                :src="item.imageUrl"
                class="avatar_img"
              />
            </div>
            <span v-html="item.content"></span>
          </div>
          <div
            v-if="item.descType == 'TEXT&IMAGE'"
            class="descText_box commonBox detail"
          >
            <span v-html="item.content"></span>
            <div class="descImage_box">
              <img
                v-if="item.imageUrl"
                :src="item.imageUrl"
                class="avatar_img"
              />
            </div>
          </div>
          <div
            v-if="item.descType == 'IMAGE&IMAGE'"
            class="descText_box commonBox detail"
          >
            <div class="descImage_box">
              <img
                v-if="item.imageUrl"
                :src="item.imageUrl"
                class="avatar_img"
              />
            </div>
            <div class="descImage_box">
              <img
                v-if="item.imageUrl1"
                :src="item.imageUrl1"
                class="avatar_img"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <xuanze-img
      v-model="xuanzeShow"
      :img-list="imgList"
      @confirm="onConfirmByXuanzeImg"
    ></xuanze-img>
  </div>
</template>
<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
import Tinymce from "@/components/Tinymce";
import XuanzeImg from "./xuanzeImg.vue";
export default {
  name: "descComp",
  components: { XuanzeImg, Tinymce },
  data() {
    return {
      //点击选择图片,tablelist 的下标
      selectImageIndex: 0,
      keuNun: 0,
      //选中总的是第几组
      selectDescIndex: 0,
      xuanzeShow: false,
      imgField: "imageUrl",
      //描述数组,用于存放点击添加行生成的数组
      descList: [],
      descType: "IMAGE",
      customHeaders: { token: localStorage.getItem("token") },
      uploadAction: Baseurl + "imageController/uploadImage",
    };
  },
  props: {
    imgList: {
      type: Array,
      default: [],
    },
    isChakan: {
      type: Boolean,
      default: false,
    },
    system: {
      type: Number,
      default: 5,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    //html标签转文本
    htmlToText(html) {
      // 首先去除 HTML 标签
      let text = html?.replace(/<br\s*\/?>/gi, "\n")?.replace(/<[^>]*>/g, "");

      // 定义 HTML 实体和对应字符的映射
      const entities = {
        "&nbsp;": " ",
        "&lt;": "<",
        "&gt;": ">",
        "&amp;": "&",
        "&quot;": '"',
        "&apos;": "'",
        "&cent;": "¢",
        "&pound;": "£",
        "&yen;": "¥",
        "&euro;": "€",
        "&copy;": "©",
        "&reg;": "®",
        "&trade;": "™",
        "&mdash;": "—",
        "&ndash;": "–",
        "&hellip;": "…",
        "&bull;": "•",
        "&raquo;": "»",
        "&laquo;": "«",
        "&sup1;": "¹",
        "&sup2;": "²",
        "&sup3;": "³",
        "&micro;": "µ",
        "&divide;": "÷",
        "&times;": "×",
        "&forall;": "∀",
        "&exist;": "∃",
        "&infin;": "∞",
        "&alpha;": "α",
        "&beta;": "β",
        "&gamma;": "γ",
        "&delta;": "δ",
        "&epsilon;": "ε",
        "&theta;": "θ",
        "&lambda;": "λ",
        "&sigma;": "σ",
        "&phi;": "φ",
        "&chi;": "χ",
        "&psi;": "ψ",
        "&omega;": "ω",
        "&deg;": "°",
        // 可以根据需要继续添加其他实体
      };

      // 替换 HTML 实体
      Object.keys(entities).forEach((entity) => {
        const regex = new RegExp(entity, "g");
        text = text.replace(regex, entities[entity]);
      });

      return text;
    },

    pasteFN(plugin, args) {
      const str = this.htmlToText(args.content);
      args.content = str
        .split(/\n+/)
        .map((p) => p.trim())
        .filter((p) => p.length > 0)
        ?.map((ele) => `<p>${ele}</p>`)
        ?.join("");
    },

    initData() {
      this.descType = "TEXT";
      this.descList = [];
    },
    //新增一个类型
    addNewType() {
      let params;
      if (this.descType == "TEXT") {
        params = {
          descType: "TEXT",
          content: "",
          dialogAddEditNoticeVisible: true,
        };
      } else if (this.descType == "IMAGE") {
        params = {
          descType: "IMAGE",
          imageUrl: "",
        };
      } else if (this.descType === "IMAGE&TEXT") {
        params = {
          descType: "IMAGE&TEXT",
          imageUrl: "",
          content: "",
        };
      } else if (this.descType === "TEXT&IMAGE") {
        params = {
          descType: "TEXT&IMAGE",
          imageUrl: "",
          content: "",
        };
      } else if (this.descType === "IMAGE&IMAGE") {
        params = {
          descType: "IMAGE&IMAGE",
          imageUrl: "",
          imageUrl1: "",
        };
      }
      this.descList.push(params);
      this.keuNun += 1;
    },
    addIamgeToItem(index, imageUrl) {
      this.xuanzeShow = true;
      this.selectDescIndex = index;
      this.imgField = imageUrl;
    },
    onConfirmByXuanzeImg(img) {
      let field = this.imgField ? this.imgField : "imageUrl";
      this.descList[this.selectDescIndex][field] = img;
    },
    handleShangyi(index) {
      this.swapArrayElements(this.descList, index, index - 1);
    },
    handleXiayi(index) {
      this.swapArrayElements(this.descList, index, index + 1);
    },
    //交换数组位置
    swapArrayElements(arr, indexA, indexB) {
      [arr[indexA], arr[indexB]] = [arr[indexB], arr[indexA]];
      this.descList = [...this.descList];
      this.keuNun += 1;
    },
    handleDelete(index) {
      this.descList.splice(index, 1);
      this.keuNun += 1;
    },
    handleCopy(index) {
      let itemObj = this.descList[index];
      this.descList.push({ ...itemObj });
      this.keuNun += 1;
    },
  },
  filters: {
    getDescTypeStr(val) {
      let str = "";
      switch (val) {
        case "TEXT":
          str = "文字";
          break;
        case "IMAGE":
          str = "图片";
          break;
        case "IMAGE&TEXT":
          str = "图片+文字";
          break;
        case "TEXT&IMAGE":
          str = "文字+图片";
          break;
        case "IMAGE&IMAGE":
          str = "图片+图片";
          break;
      }
      return str;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../ozon.less";

.input_bot_tip {
  display: flex;
  flex-direction: column;
}

.desc_item_box {
  overflow: hidden;
  position: relative;
  display: flex;
  width: calc(100% - 22px);

  .descText_title {
    width: 8%;
    overflow: hidden;
    color: #7d7171;
    text-align: right;
    float: left;
    line-height: 33px;
    margin-right: 1%;
    font-weight: bold;
    user-select: none;

    .tips {
      color: red;
    }
  }

  .descText_box {
    width: 88%;

    .opea_title {
      height: 36px;
      background: rgba(127, 127, 127, 0.5);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;

      .opea_button {
        display: flex;
        align-items: center;

        .icon_item {
          font-size: 20px;
          margin-right: 10px;
          cursor: pointer;
        }
      }
    }
  }

  .descImage_box {
    min-height: 160px;
    width: calc(100% - 22px);
    overflow: hidden;
    padding: 10px 10px;
    border: 1px solid rgba(168, 168, 168, 0.8);
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-top: none !important;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
  }

  .commonBox {
    display: flex;
    .descText {
      flex: 1;
    }
    .descImage_box {
      width: 320px;
      border-radius: 0;
      margin-bottom: 10px;
      height: 323px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &.detail {
      gap: 12px;
      .descImage_box {
        border: 0;
        padding: 0;
      }
    }
  }
}

.add-notice-row {
  margin-bottom: 10px;

  .title {
    flex-shrink: 0;
    margin-right: 10px;
  }
}

.avatar_img {
  width: 320px;
  height: 320px;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.add_img_icon {
  font-size: 200px;
  cursor: pointer;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
}
</style>
